export const COLOR_PICKER = 'COLOR_PICKER';
export const COLOR_PALETTE_MENU = 'COLOR_PALETTE_MENU';

export const COLOR_CARD_SIZE = 32;

export const KEY_SPACE = ' ';
export const KEY_ENTER = 'Enter';
export const KEY_ARROW_UP = 'ArrowUp';
export const KEY_ARROW_DOWN = 'ArrowDown';
export const KEY_ARROW_LEFT = 'ArrowLeft';
export const KEY_ARROW_RIGHT = 'ArrowRight';
export const KEY_TAB = 'Tab';
export const KEY_ESCAPE = 'Escape';
